<ng-template #modalRef>
  <div
    class="pl-modal--{{ size }} child-sale-modal-shell"
    [ngClass]="{ 'step-two-min-height': step === 2 }">
    <div class="header-close-icon">
      <header class="pl-modal__header se-modal__header">
        <h1
          pl-grid="1/1@phone"
          pl-grid-el
          class="pl-heading--large se-modal__header--text">
          {{ 'CHILD_SALE.BULK.title' | translate }}
          <se-fe-icon
            (click)="closeForm()"
            seFeDataName="remove"
            seFeDataEmphasis="low"
            class="close-button"
            data-testid="close-button"></se-fe-icon>
        </h1>
      </header>
      <div class="progress-bar-div">
        <se-fe-progress-bar
          aria-labelledby="progress-bar"
          [seFeDataSegmented]="true"
          [seFeDataCompleted]="completed"
          [seFeDataTotal]="total"
          style="height: 4px"></se-fe-progress-bar>
        <div id="progress-bar">
          <span class="progress-bar">
            {{ 'CHILD_SALE.BULK.progress' | translate: { completed: completed, total: total } }}
          </span>
        </div>
      </div>
      <div class="sale-info">
        @if (step === 1) {
<h3

          data-testid="bulk-step1-header">
          {{
            (parent_sales.length === 1 ? 'CHILD_SALE.BULK.step1_header_one' : 'CHILD_SALE.BULK.step1_header_other')
              | translate: { count: parent_sales.length }
          }}
        </h3>
}
        @if (step === 2) {
<h3

          data-testid="bulk-step2-header">
          {{
            (parent_sales.length === 1 ? 'CHILD_SALE.BULK.step2_header_one' : 'CHILD_SALE.BULK.step2_header_other')
              | translate: { count: parent_sales.length }
          }}
        </h3>
}
        @if (step === 3) {
<h3

          data-testid="bulk-step3-header">
          {{ 'CHILD_SALE.BULK.step3_header' | translate }}
        </h3>
}
      </div>
    </div>

    <!-- Step 1: Item Selection -->
    @if (step === 1) {
<section

      #scrollRef
      class="pl-modal__content">
      <se-fe-alert
        style="margin-bottom: 1rem"
        data-testid="bulk-order-count-alert">
        {{
          (parent_sales.length === 1 ? 'CHILD_SALE.BULK.creating_alert_one' : 'CHILD_SALE.BULK.creating_alert_other')
            | translate: { count: parent_sales.length }
        }}
        <se-fe-alert-subheader>
          {{ 'CHILD_SALE.BULK.creating_alert_sub' | translate }}
        </se-fe-alert-subheader>
      </se-fe-alert>

      @if (exceedsMaxOrders) {
<se-fe-alert

        style="margin-bottom: 1rem"
        seFeDataType="critical"
        data-testid="bulk-max-exceeded-alert">
        {{ 'CHILD_SALE.BULK.max_exceeded' | translate: { max: maxOrders } }}
        <se-fe-alert-subheader>
          {{ 'CHILD_SALE.BULK.max_exceeded_sub' | translate: { max: maxOrders } }}
        </se-fe-alert-subheader>
      </se-fe-alert>
}

      <form [formGroup]="multiselectForm">
        <label class="pl-field__label">{{ 'CHILD_SALE.MODAL.form_message' | translate }}</label>
        <div
          pl-grid="1/1@phone"
          pl-grid-el
          class="flex">
          <div
            pl-grid="5/6@phone"
            pl-grid-el>
            <se-fe-form-field-multiselect
              class="multiselect"
              #itemSelector
              id="childSale"
              data-item-search
              [attr.aria-busy]="itemSearchStatus === 'loading' ? 'true' : null"
              formControlName="multiselect"
              seFeDataMaxInput="1"
              [seFeDataHideSearchIcon]="true"
              [seFeDataOptions]="options"
              [seFeDataSearchMinLength]="itemSearchMinLength"
              [seFeDataQueryValidators]="queryValidators"
              [seFeDataComfy]="false"
              [seFeDataNotFoundMessage]="itemSearchNotFoundMessageKey | translate"
              seFeDataPlaceholder="Select"
              [seFeDataQueryConfig]="queryConfig"
              (seFeQueryChange)="searchInput($event, true, itemSelector)"
              data-testid="item-selector"></se-fe-form-field-multiselect>
            @if (itemSearchStatusMessageKey; as messageKey) {
<div

              class="pl-help-text--below item-search-status"
              data-testid="item-search-status"
              aria-live="polite">
              {{ messageKey | translate }}
              @if (itemSearchStatus === 'error') {
<se-fe-button

                seFeDataEmphasis="low"
                [seFeDataSmall]="true"
                (click)="retryItemSearch()"
                data-testid="item-search-retry">
                {{ 'CHILD_SALE.MODAL.item_search_retry' | translate }}
              </se-fe-button>
}
            </div>
}
            @if (itemSearchStatus === 'empty') {
<se-fe-button

              seFeDataEmphasis="low"
              [seFeDataSmall]="true"
              (click)="clearItemSearch()"
              data-testid="item-search-clear">
              {{ 'CHILD_SALE.MODAL.item_search_clear' | translate }}
            </se-fe-button>
}
            @if (!itemError) {
<span

              class="error-item">
              {{ 'CHILD_SALE.MODAL.item_error' | translate }}.
            </span>
}
          </div>
          <div
            pl-grid="1/6@phone"
            pl-grid-el>
            <se-fe-button
              (click)="apply()"
              class="apply-button"
              seFeDataEmphasis="medium"
              [seFeDataIsDisabled]="!multiselectForm.controls['multiselect'].value">
              {{ 'CHILD_SALE.MODAL.apply_button' | translate }}
            </se-fe-button>
          </div>
        </div>
      </form>
      <form [formGroup]="form">
        @if (getItems().length > 0) {
<se-fe-block
          seFeDataType="outline"
          class="selected-items-container"
         >
          <div
            pl-grid="1/1@phone"
            pl-grid-el>
            <div
              pl-grid="tight"
              class="tight-container">
              <h3>{{ 'CHILD_SALE.MODAL.item_selector' | translate }}</h3>
              <div
                pl-grid="1/2@phone"
                pl-grid-el
                class="pl-help-text--below">
                {{ 'CHILD_SALE.MODAL.item_selector_subtitle' | translate }}
              </div>
              <div
                pl-grid="1/2@phone"
                pl-grid-el
                class="flex">
                <h5
                  pl-grid="1/12@phone"
                  pl-grid-el>
                  {{ 'CHILD_SALE.MODAL.item_selector_items' | translate }}
                </h5>
                <h5
                  pl-grid="1/8@phone"
                  class="pl-text--right">
                  {{ 'CHILD_SALE.MODAL.item_selector_quantity' | translate }}
                </h5>
                <h5
                  pl-grid="1/12@phone"
                  class="pl-text--right">
                  {{ 'CHILD_SALE.BULK.amount_column' | translate }}
                </h5>
              </div>
              <hr class="pl-divider modal-divider" />
              @for (itemGroup of getItems().controls; track itemGroup; let i = $index) {
<div>
                <div
                  [formGroup]="itemGroup"
                  pl-grid="1/1@phone"
                  pl-grid-el
                  class="flex">
                  <label
                    class="pl-field__label"
                    pl-grid="1/6@phone"
                    [seFeTooltipTrigger]="tooltipRef"
                    [attr.data-testid]="'item-name-' + i">
                    {{ $safeNavigationMigration(itemGroup.get('item')?.value?.text) | trim }}
                  </label>
                  <se-fe-tooltip
                    #tooltipRef
                    class="tooltip">
                    {{ itemGroup.get('item')?.value?.text }}
                  </se-fe-tooltip>
                  <div
                    pl-grid-el
                    pl-grid="1/4@phone">
                    <se-fe-form-field-quantity
                      seFeDataMin="1"
                      seFeDataMax="999"
                      formControlName="quantity"
                      aria-label="Quantity"
                      [seFeEnableManualInput]="true"
                      style="margin-top: -0.5rem"
                      [attr.data-testid]="'item-quantity-' + i"></se-fe-form-field-quantity>
                  </div>
                  <div
                    pl-grid-el
                    pl-grid="1/12@phone">
                    <span
                      class="amount-display"
                      [attr.data-testid]="'item-amount-' + i">
                      {{ getItemAmount(i) | currency }}
                    </span>
                  </div>
                  <div
                    pl-grid-el
                    pl-grid="1/12@phone">
                    <span
                      class="remove-button"
                      (click)="removeItem(i)"
                      [attr.data-testid]="'remove-item-' + i">
                      {{ 'CHILD_SALE.MODAL.remove_button' | translate }}
                    </span>
                  </div>
                </div>
              </div>
}
              <hr class="pl-divider modal-divider" />
              <div
                pl-grid="1/1@phone"
                pl-grid-el
                class="total-items">
                <h5 data-testid="total-items">
                  {{ getItemsTotal() | currency }} {{ 'CHILD_SALE.BULK.per_order' | translate }} ({{ getTotalItems() }}
                  {{ 'CHILD_SALE.MODAL.item_selector_total_items' | translate }})
                </h5>
              </div>
            </div>
            @if (itemsAreInvalid()) {
<span
              class="error-item"
             >
              {{ 'CHILD_SALE.BULK.items_error' | translate }}
            </span>
}
          </div>
        </se-fe-block>
}
        <div
          class="textarea"
          style="margin-top: 1rem">
          <se-fe-form-field [seFeDataConfig]="descriptionConfig">
            <se-fe-form-field-text
              formControlName="description"
              maxlength="255"
              data-testid="linked-sale-description"></se-fe-form-field-text>
          </se-fe-form-field>
          <label class="pl-field__label">
            {{ 'CHILD_SALE.BULK.description_help' | translate }}
          </label>
        </div>
        <div class="textarea">
          <se-fe-form-field [seFeDataConfig]="textareaConfig">
            <se-fe-form-field-text
              formControlName="textarea"
              [seFeDataRows]="6"
              data-testid="linked-sale-message"></se-fe-form-field-text>
          </se-fe-form-field>
          <label class="pl-field__label">
            {{ 'CHILD_SALE.MODAL.text_area' | translate }}
          </label>
        </div>
      </form>
    </section>
}

    <!-- Step 2: Due Date + Credit -->
    @if (step === 2) {
<section

      class="pl-modal__content">
      <h3>
        {{
          'CHILD_SALE.BULK.step2_collect_payment'
            | translate: { amount: (getItemsTotal() | currency), count: getTotalItems() }
        }}
      </h3>
      <form [formGroup]="form">
        <se-fe-form-field [seFeDataConfig]="dueDateConfig">
          <se-fe-datepicker
            formControlName="due_date"
            [seFeDataConfig]="dueDateConfig"
            [seFeDataExcludeDates]="excludeDates"
            [seFeDataYearRange]="{ future: 10, past: 10 }"></se-fe-datepicker>
          <div seFeHelp>
            {{ 'CHILD_SALE.BULK.due_date_help' | translate }}
          </div>
        </se-fe-form-field>
        <div
          pl-grid="1/1@phone"
          pl-grid-el
          class="flex"
          style="padding: 14px 0">
          <se-fe-checkbox
            seFeDataId="apply_credit"
            formControlName="apply_credit">
            <ng-template seFeFormFieldLabel>
              {{ 'CHILD_SALE.BULK.apply_credit_label' | translate }}
            </ng-template>
          </se-fe-checkbox>
          <se-fe-form-control-help>
            <div seFeHelp>
              {{ 'CHILD_SALE.BULK.apply_credit_help' | translate }}
            </div>
          </se-fe-form-control-help>
        </div>
        @if (form.controls['apply_credit'].value) {
<se-fe-form-field
          [seFeDataConfig]="creditAmountConfig"
         >
          <se-fe-form-field-text
            class="input-field"
            (input)="onCurrencyInput($event)"
            formControlName="credit_amount"
            [attr.data-testid]="'credit-amount-input'"></se-fe-form-field-text>
          <div seFeHelp>
            {{ 'CHILD_SALE.BULK.credit_up_to' | translate: { amount: (getItemsTotal() | currency) } }}
          </div>
        </se-fe-form-field>
}
        @if (form.controls['apply_credit'].value) {
<div
          class="credit-reason-container"
         >
          <se-fe-form-field [seFeDataConfig]="creditReasonConfig">
            @if (creditReasonOptions.sections[0].options.length) {
<se-fe-form-field-multiselect

              class="credit-reason-multiselect"
              #creditReason
              id="creditReason"
              formControlName="credit_reason"
              [seFeDataOptions]="creditReasonOptions"
              seFeDataPlaceholder="Select"
              seFeDataMaxInput="1"
              [seFeDataComfy]="false"
              [seFeDataEnableAddNew]="true"
              [attr.data-testid]="'credit-reason-selector'"></se-fe-form-field-multiselect>
} @else {

              <se-fe-form-field-text
                formControlName="credit_reason"
                data-testid="credit-reason-input"></se-fe-form-field-text>

}

          </se-fe-form-field>
          <se-fe-form-control-help>
            <div seFeHelp>
              {{ 'CHILD_SALE.BULK.credit_reason_help' | translate }}
            </div>
          </se-fe-form-control-help>
        </div>
}
      </form>
    </section>
}

    <!-- Step 3: Review -->
    @if (step === 3) {
<section

      class="pl-modal__content">
      @if (!error) {
<se-fe-alert

        style="margin: 1rem"
        data-testid="info-alert">
        {{
          (parent_sales.length === 1 ? 'CHILD_SALE.BULK.about_to_create_one' : 'CHILD_SALE.BULK.about_to_create_other')
            | translate: { count: parent_sales.length }
        }}
        <se-fe-alert-subheader>
          {{ 'CHILD_SALE.BULK.about_to_create_sub' | translate }}
        </se-fe-alert-subheader>
      </se-fe-alert>
}
      @if (error) {
<se-fe-alert

        style="margin: 1rem"
        seFeDataType="critical">
        {{ 'CHILD_SALE.MODAL.info_error' | translate }}
        <se-fe-alert-subheader>
          {{ 'CHILD_SALE.MODAL.info_error_subtitle' | translate }}
        </se-fe-alert-subheader>
      </se-fe-alert>
}
      <div
        pl-grid="1/1@phone"
        pl-grid-el
        style="display: block; margin: 1rem">
        <div
          pl-grid="1/1@phone"
          style="margin-bottom: 1rem">
          <div
            pl-grid="1/2@phone"
            class="block">
            <label class="pl-field__label label-medium">{{ 'CHILD_SALE.BULK.orders_label' | translate }}</label>
            <label class="pl-field__label">
              {{
                (parent_sales.length === 1 ?
                  'CHILD_SALE.BULK.orders_selected_one'
                : 'CHILD_SALE.BULK.orders_selected_other'
                ) | translate: { count: parent_sales.length }
              }}
            </label>
          </div>
          <div
            pl-grid="1/2@phone"
            class="block">
            <label class="pl-field__label label-medium">{{ 'CHILD_SALE.BULK.payment_terms_label' | translate }}</label>
            <label
              class="pl-field__label"
              [attr.data-testid]="'payment-terms-due-date'">
              {{
                'CHILD_SALE.BULK.autopay_on' | translate: { date: (form.controls['due_date'].value | formattedDate) }
              }}
            </label>
          </div>
        </div>
        <div
          pl-grid="1/1@phone"
          style="margin-bottom: 1rem">
          <div
            pl-grid="1/1@phone"
            class="block">
            <label class="pl-field__label label-medium">{{ 'CHILD_SALE.BULK.description_label' | translate }}</label>
            <label class="pl-field__label">
              {{ form.controls['description'].value || ('CHILD_SALE.BULK.description_default' | translate) }}
            </label>
          </div>
        </div>
        @if (form.controls['textarea'].value) {
<div
          pl-grid="1/1@phone"
          class="block"
         >
          <label class="pl-field__label label-medium">{{ 'CHILD_SALE.MODAL.message' | translate }}</label>
          <label class="pl-field__label">{{ form.controls['textarea'].value }}</label>
        </div>
}
        <hr class="pl-divider" />
        @for (itemGroup of getItems().controls; track itemGroup; let i = $index) {
<div

          pl-grid="1/1@phone"
          class="block">
          <div
            [formGroup]="itemGroup"
            pl-grid="1/1@phone">
            <div pl-grid="1/6@phone">
              <label
                class="pl-field__label"
                [attr.data-testid]="'item-name-' + i">
                {{ itemGroup.get('item')?.value?.text }}
              </label>
            </div>
            <div>
              <label
                class="pl-field__label"
                [attr.data-testid]="'item-quantity-summary-' + i">
                <span>{{ getPriceOrPriceVariation(items[i]) | currency }}</span>
                <span style="margin-left: 1rem">x{{ itemGroup.get('quantity')?.value }}</span>
                <span style="margin-left: 1rem">
                  {{ getSum(getPriceOrPriceVariation(items[i]), $safeNavigationMigration(itemGroup.get('quantity')?.value)) | currency }}
                </span>
                @if (priceVariationIsActive(items[i])) {
<span
                  style="margin-left: 1rem"
                 >
                  <label [seFeTooltipTrigger]="variationWarning">
                    <se-fe-icon
                      seFeDataName="info_circle"
                      seFeDataEmphasis="low"></se-fe-icon>
                  </label>
                  <se-fe-tooltip
                    #variationWarning
                    class="tooltip">
                    {{ 'CHILD_SALE.BULK.price_variation_tooltip' | translate }}
                  </se-fe-tooltip>
                </span>
}
              </label>
            </div>
          </div>
        </div>
}
        <hr class="pl-divider" />
        <div
          pl-grid="1/1@phone"
          class="block">
          <div pl-grid="1/1@phone">
            <div pl-grid="1/2@phone">
              <label class="pl-field__label">
                {{
                  (getItems().length === 1 ?
                    'CHILD_SALE.BULK.subtotal_per_order_one'
                  : 'CHILD_SALE.BULK.subtotal_per_order_other'
                  ) | translate: { count: getItems().length }
                }}
              </label>
            </div>
            <div>
              <label
                class="pl-field__label"
                data-testid="subtotal-amount">
                {{ itemsSum() | currency }}
              </label>
            </div>
          </div>
        </div>
        @if (form.controls['credit_amount'].value) {
<div
          pl-grid="1/1@phone"
          class="block"
         >
          <div pl-grid="1/1@phone">
            <div pl-grid="1/2@phone">
              <label class="pl-field__label">{{ 'CHILD_SALE.BULK.credit_per_order' | translate }}</label>
            </div>
            <div>
              <label
                class="pl-field__label"
                data-testid="credit-amount">
                ({{ form.controls['credit_amount'].value | currency }})
              </label>
            </div>
          </div>
        </div>
}
        @if (getCustomerFeeAmount() > 0) {
<div
          pl-grid="1/1@phone"
          class="block"
         >
          <div pl-grid="1/1@phone">
            <div pl-grid="1/2@phone">
              <label class="pl-field__label">{{ 'CHILD_SALE.BULK.customer_fees' | translate }}</label>
            </div>
            <div>
              <label
                class="pl-field__label"
                data-testid="total-fees">
                {{ getCustomerFeeAmount() | currency }}
              </label>
            </div>
          </div>
        </div>
}
        <hr class="pl-divider" />
        <div
          pl-grid="1/1@phone"
          class="block">
          <div pl-grid="1/1@phone">
            <div pl-grid="1/2@phone">
              <label
                class="pl-field__label"
                style="font-weight: bold">
                {{
                  (getItems().length === 1 ?
                    'CHILD_SALE.BULK.total_per_order_one'
                  : 'CHILD_SALE.BULK.total_per_order_other'
                  ) | translate: { count: getItems().length }
                }}
              </label>
            </div>
            <div>
              <label
                class="pl-field__label"
                data-testid="total-per-order"
                style="font-weight: bold">
                {{ getTotalCharged() | currency }}
              </label>
            </div>
          </div>
        </div>
        <div
          pl-grid="1/1@phone"
          class="block">
          <div pl-grid="1/1@phone">
            <div pl-grid="1/2@phone">
              <label
                class="pl-field__label"
                style="font-weight: bold">
                {{
                  (parent_sales.length === 1 ?
                    'CHILD_SALE.BULK.total_all_orders_one'
                  : 'CHILD_SALE.BULK.total_all_orders_other'
                  ) | translate: { count: parent_sales.length }
                }}
              </label>
            </div>
            <div>
              <label
                class="pl-field__label"
                data-testid="total-all-orders"
                style="font-weight: bold">
                {{ getTotalForAllOrders() | currency }}
              </label>
            </div>
          </div>
        </div>
        @if (getOrganizationFeeAmount() > 0) {
<div
          pl-grid="1/1@phone"
          class="block"
         >
          <div pl-grid="1/1@phone">
            <div pl-grid="1/2@phone">
              <label class="pl-field__label">{{ 'CHILD_SALE.BULK.org_fees' | translate }}</label>
            </div>
            <div>
              <label
                class="pl-field__label"
                data-testid="total-org-fees">
                {{ getOrganizationFeeAmount() | currency }}
              </label>
            </div>
          </div>
        </div>
}
        <p
          class="organization-receive-label"
          data-testid="organization-will-receive-label">
          {{
            (parent_sales.length === 1 ? 'CHILD_SALE.BULK.org_receive_one' : 'CHILD_SALE.BULK.org_receive_other')
              | translate: { amount: (getOrgReceiveAmount() | currency), count: parent_sales.length }
          }}
        </p>
        <hr class="pl-divider" />
        <section
          class="cardholder-authorization"
          data-testid="cardholder-authorization">
          <h4 class="cardholder-authorization__title">
            <se-fe-icon
              class="cardholder-authorization__icon"
              seFeDataName="warning"
              seFeDataSize="500"></se-fe-icon>
            {{ 'CHILD_SALE.BULK.cardholder_authorization_title' | translate }}
          </h4>
          <p
            class="pl-field__label"
            data-testid="cardholder-authorization-confirmation">
            {{
              getCardholderAuthorizationConfirmationKey()
                | translate
                  : { lastFour: getMaskedSharedPaymentMethodLastFour(), amount: (getTotalCharged() | currency) }
            }}
          </p>
          <p class="pl-field__label">
            {{ 'CHILD_SALE.BULK.cardholder_authorization_responsibility' | translate }}
          </p>
          <form [formGroup]="form">
            <se-fe-checkbox
              class="cardholder-authorization__checkbox"
              formControlName="cardholder_authorization"
              data-testid="cardholder-authorization-checkbox">
              <ng-template seFeFormFieldLabel="cardholder_authorization">
                <strong>{{ 'CHILD_SALE.BULK.cardholder_authorization_checkbox' | translate }}</strong>
              </ng-template>
            </se-fe-checkbox>
          </form>
        </section>
      </div>
    </section>
}

    <footer class="pl-modal__footer">
      <div class="pl-form-actions__button-container modal-footer-container">
        @if (step === 2 || step === 3) {
<div
          pl-grid="1/2@phone"
         >
          <se-fe-back-button (click)="back()">
            {{ 'CHILD_SALE.MODAL.back_button' | translate }}
          </se-fe-back-button>
        </div>
}
        <div class="cancel-button">
          <se-fe-button
            [seFeDataEmphasis]="'low'"
            (click)="closeForm()"
            style="height: 36px !important">
            {{ 'CHILD_SALE.MODAL.cancel_button' | translate }}
          </se-fe-button>
        </div>
        @if (step === 1 || step === 2) {
<se-fe-button

          [seFeDataEmphasis]="'high'"
          (click)="nextStep()"
          [seFeDataIsDisabled]="disabled || exceedsMaxOrders || (step === 2 && form.invalid)"
          data-testid="next-button"
          style="height: 36px !important">
          {{ 'CHILD_SALE.MODAL.next_button' | translate }}
        </se-fe-button>
}
        @if (step === 3) {
<se-fe-button

          [seFeDataEmphasis]="'high'"
          (click)="submitForm()"
          [seFeDataIsDisabled]="
            submitIsInProgress || exceedsMaxOrders || !form.controls['cardholder_authorization'].value
          "
          data-testid="submit-button">
          @if (submitIsInProgress) {
<se-fe-spinner

            [seFeDataSize]="200"
            style="display: inline-block; margin-right: 8px; vertical-align: middle"></se-fe-spinner>
}
          {{
            submitIsInProgress ?
              ('CHILD_SALE.BULK.submit_in_progress' | translate)
            : ((parent_sales.length === 1 ? 'CHILD_SALE.BULK.submit_button_one' : 'CHILD_SALE.BULK.submit_button_other')
              | translate: { count: parent_sales.length })
          }}
        </se-fe-button>
}
      </div>
    </footer>
  </div>
</ng-template>
